import { render, staticRenderFns } from "./DatafastFooter.vue?vue&type=template&id=7eef59c6&scoped=true"
import script from "./DatafastFooter.vue?vue&type=script&lang=js"
export * from "./DatafastFooter.vue?vue&type=script&lang=js"
import style0 from "./DatafastFooter.vue?vue&type=style&index=0&id=7eef59c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eef59c6",
  null
  
)

export default component.exports